export default ".txt-bold {\n  font-weight: bold;\n  text-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);\n}";